export const truncateText = (
  text: string | number,
  maxLength: number
): string => {
  const textStr = String(text ?? '');
  return textStr.length > maxLength
    ? `${textStr.slice(0, maxLength)}...`
    : textStr;
};
